export default "__VITE_ASSET__CA2R35gg__"